import { render, staticRenderFns } from "./FormatKpiValue.vue?vue&type=template&id=bbef7346&"
import script from "./FormatKpiValue.vue?vue&type=script&lang=js&"
export * from "./FormatKpiValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports